module.exports = __webpack_public_path__ + "fonts/a77141f671e046fd9f264ac9cc767469.ttf";